angular.module('logbook').directive('sentinelProvisioning', ['$filter', function($filter) {
   return {
      restrict: 'E',
	  template: require('./sentinel-provisioning.html'),

      link: function(scope) {
         scope.$parent.selectedType = "Door";

         scope.getDoorName = function(instance) {
            var val = JSON.parse(instance.value);
            return val.accessPointName ? val.accessPointName : "No name";
         };

         scope.getFacilityName = function(instance) {
            if (!instance) return "";
            var val = JSON.parse(instance.value);
            return scope.instanceNames[val.facility];
         };

         scope.editInstance = function(instance, selectedType) {
            scope.$parent.setSelectedType(selectedType);
            scope.$parent.editInstance(instance);
         };

         scope.submit = function(instance) {
            if (scope.selectedFacility && scope.selectedFacility !== 'new') scope.savedSelectedFacility = scope.selectedFacility._links.self.href;
            if (scope.selectedFacility === 'new') scope.savedSelectedFacility = 'new';
            // For newly added doors, default "Facility" to currently selected facility.
            if (scope.$parent.selectedType === 'Door' && !scope.editingInstanceModel.facility)
               scope.editingInstanceModel.facility = scope.selectedFacility._links.self.href;

            scope.$parent.submit(instance);
         };

         scope.cancelEditing = function() {
            if (scope.selectedFacility === 'new') scope.selectedFacility = null;
            scope.$parent.cancelEditing();
         };

         // If instance is a facility, delete its doors first.
         scope.deleteFacility = function(instance) {
            var facilityDoors = $filter('facilityFilter')(scope.instances, scope.instanceNames, scope.instanceNames[scope.selectedFacility._links.self.href].substring(9));
            facilityDoors.forEach(function(door) {
               scope.deleteInstance(door);
            });
            scope.deleteInstance(instance);
         };

         scope.$on('updateConfigs', function() {
            var facs = $filter('filter')(scope.instances, {key: scope.selectedProduct+'.instance.facility.'});
            if (!scope.selectedFacility && facs.length === 1) {
               scope.selectedFacility = facs[0];
               return;
            }
            if (!scope.savedSelectedFacility) return;
            if (scope.savedSelectedFacility === 'new') scope.selectedFacility = scope.instances[scope.instances.length - 1];
            for (var i = 0; i < scope.instances.length; i++) {
               if (scope.savedSelectedFacility === scope.instances[i]._links.self.href) {
                  scope.selectedFacility = scope.instances[i];
                  break;
               }
            }
         });

      }
    };
}])

.filter("facilityFilter", function() {
   return function(input, instanceNames, fac) {
      var output = [];

      if (!input || !instanceNames) return [];

      input.forEach(function(instance) {
         var val = JSON.parse(instance.value);
         if (!val.facility) return;
         var instanceFacility = instanceNames[val.facility];
         if (!instanceFacility) return;
         instanceFacility = instanceFacility.substring(9);
         if (instanceFacility === fac) output.push(instance);
      });

      return output;
   }
});